import {
  FEEDBACK_OPEN,
  FEEDBACK_CLOSE,
  FEEDBACK_CLEAR_FORM,
  FEEDBACK_SEND_FAILED,
  FEEDBACK_SEND_REQUEST,
  FEEDBACK_SEND_SUCCESS,
  FEEDBACK_REPORT_WRONG_PRICE,
} from '../actions';

const reducer = (state, action) => {
  if (!state) {
    return {
      id: 0,
      open: false,
      sending: false,
      thanks: false,
      error: undefined,
      email: undefined,
    };
  }

  switch (action.type) {
    case '__DANGEROUS_CONFIG_RECEIVE': {
      return {
        ...state,
        group: action.server.feedbackGroup,
        tag: action.server.feedbackTag,
      };
    }
    case FEEDBACK_OPEN: {
      return {
        ...state,
        open: true,
      };
    }
    case FEEDBACK_CLOSE: {
      return {
        ...state,
        open: false,
      };
    }
    case FEEDBACK_CLEAR_FORM: {
      return {
        ...state,
        id: state.id + 1,
        thanks: false,
        error: undefined,
        open: false,
      };
    }
    case FEEDBACK_SEND_REQUEST: {
      return {
        ...state,
        sending: true,
      };
    }
    case FEEDBACK_REPORT_WRONG_PRICE: {
      return {
        ...state,
        sending: true,
      };
    }
    case FEEDBACK_SEND_SUCCESS: {
      return {
        ...state,
        sending: false,
        thanks: true,
      };
    }
    case FEEDBACK_SEND_FAILED: {
      return {
        ...state,
        sending: false,
        error: action.message,
        thanks: false,
      };
    }

    case 'SESSION_RECEIVE': {
      return {
        ...state,
        email: action.session.email,
      };
    }

    default:
  }

  return state;
};

export default reducer;
